'use client'

import { useGoogleMapsScript, Libraries } from 'use-google-maps-script'
import { env } from '@/lib/env'

const libraries: Libraries = ['drawing', 'geometry', 'places']

export default function GoogleMapsScriptProvider({ children }: { children: React.ReactNode }) {
  const { isLoaded, loadError } = useGoogleMapsScript({
    googleMapsApiKey: env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    libraries,
  })

  if (!isLoaded) return null
  if (loadError) return <div>Error loading script</div>
  return <>{children}</>
}
